import type { CommunityTopic } from '@features/communityContent/topics'
import type { Database } from '@hvf/contracts'
import { createEffect, createSignal } from 'solid-js'

export type GoWatchView = 'card' | 'rail'
export type GoWatchCols = 3 | 4 | 5

export interface EditableGoWatchVideo {
	id: string
	title: string
	topic: CommunityTopic
	provider: Database['public']['Enums']['video_providers']
	provider_id: string
	thumbnail_url: string | null
	description: string | null
}

const VIEW_KEY = 'go_watch_view'
const COLS_KEY = 'go_watch_cols'
const TOPIC_KEY = 'go_watch_topic_filter'

export function useState() {
	const [editVideo, setEditVideo] = createSignal<EditableGoWatchVideo | undefined>()
	const [isCreateFormOpen, setIsCreateFormOpen] = createSignal(false)

	const [view, setView] = createSignal<GoWatchView>(
		(localStorage.getItem(VIEW_KEY) as GoWatchView) || 'card',
	)
	const [cols, setCols] = createSignal<GoWatchCols>(
		(Number(localStorage.getItem(COLS_KEY)) as GoWatchCols) || 4,
	)
	const [topicFilter, setTopicFilter] = createSignal<CommunityTopic | 'all' | 'mine'>(
		(localStorage.getItem(TOPIC_KEY) as CommunityTopic | 'all' | 'mine') || 'all',
	)
	const [search, setSearch] = createSignal('')

	createEffect(() => localStorage.setItem(VIEW_KEY, view()))
	createEffect(() => localStorage.setItem(COLS_KEY, String(cols())))
	createEffect(() => localStorage.setItem(TOPIC_KEY, topicFilter()))

	createEffect(() => {
		if (isCreateFormOpen() === false) {
			setEditVideo(undefined)
		}
	})

	createEffect(() => {
		if (editVideo()) {
			setIsCreateFormOpen(true)
		}
	})

	return {
		editVideo,
		setEditVideo,
		isCreateFormOpen,
		setIsCreateFormOpen,
		view,
		setView,
		cols,
		setCols,
		topicFilter,
		setTopicFilter,
		search,
		setSearch,
	}
}
